import './SearchLoading.svelte.css';
/* src/components/searchResult/SearchLoading.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	add_render_callback,
	attr,
	create_bidirectional_transition,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "../../../_snowpack/pkg/svelte/internal.js";

import { fade } from '../../../_snowpack/pkg/svelte/transition.js';

function create_fragment(ctx) {
	let div;
	let div_transition;
	let current;

	return {
		c() {
			div = element("div");

			div.innerHTML = `loading...<br/> 
	<svg class="loading-icon svelte-17q1gf9" viewBox="0 0 24 24"><path d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z"></path></svg>`;

			attr(div, "class", "search-panel-loading svelte-17q1gf9");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { delay: 250, duration: 300 }, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { delay: 250, duration: 300 }, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching && div_transition) div_transition.end();
		}
	};
}

class SearchLoading extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default SearchLoading;